import { createFileRoute } from '@tanstack/react-router'
import { clientPageSearchSchema } from '@/features/clients/model'
import { ClientScreen } from '@/features/clients/routes/client-screen'

export const Route = createFileRoute('/clients/$clientId')({
  // ?tab=overview | jobs | invoices | messages | location-<id>
  validateSearch: clientPageSearchSchema,
  component: ClientPage,
})

function ClientPage() {
  const { clientId } = Route.useParams()
  const { tab, add, invoice } = Route.useSearch()
  return <ClientScreen clientId={clientId} tab={tab} add={add} invoice={invoice} />
}
